module.exports = __webpack_public_path__ + "static/media/logo.ce14473d.png";